import { Box, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
export const Home = () => {
  return (
    <Box sx={{ padding: 3 }} mt={10}>
      <Paper elevation={3} sx={{ padding: 3 }}>
        <Typography variant="h5" gutterBottom>
          Welcome 👋
        </Typography>
        <Typography variant="h6" sx={{ fontSize: "1rem" }} gutterBottom>
          Feel free to explore the
          <span
            style={{
              padding: " 2px 5px",
              margin: "0 5px",
              borderRadius: "6px",
              width: "auto",
              fontSize: "1rem",
              background: "#16404D",
              color: "#fff",
            }}
          >
            available pages
          </span>{" "}
          in the menu section
        </Typography>
      </Paper>
    </Box>
  );
};
